import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2533d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_6 = { class: "general" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Crear Médico")
], -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Personales")
], -1))
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "no"
}, "No.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "rncEmisor"
}, "Cédula:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "emisor"
}, "Nombre Completo:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccionEmisor"
}, "Dirección:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "estatus"
}, "Sexo:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Masculino", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Femenino", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "especialidad"
}, "Especialidad:", -1))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Profesionales")
], -1))
const _hoisted_22 = { class: "grid" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "exq"
}, "Exequatur:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cmd"
}, "Colegio Médico:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "claveDGII"
}, "Clave DGII:", -1))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de Contacto")
], -1))
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefono"
}, "Teléfonos:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "email"
}, "Email:", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Otros")
], -1))
const _hoisted_33 = { class: "grid" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "observaciones"
}, "Observaciones:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "estatus"
}, "Estatus:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Activo", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Inactivo", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Comprobantes Fiscales")
], -1))
const _hoisted_41 = { class: "grid" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "compGuberAsig"
}, "B15:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechGuberAsig"
}, "Vencimiento:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "compNoGuberAsig"
}, "B01:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechNoGuberAsig"
}, "Vencimiento B01:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechNoGuberAsig"
}, "Vencimiento B15:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "compNdAsig"
}, "B03:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "compNcAsig"
}, "B04:", -1))
const _hoisted_49 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/medicos"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "no",
                  type: "no",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.medico.no) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.no]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  id: "rncEmisor",
                  type: "rncEmisor",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.medico.rncEmisor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.rncEmisor]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  id: "emisor",
                  type: "emisor",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.medico.emisor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.emisor]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "direccionEmisor",
                  type: "direccionEmisor",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.medico.direccionEmisor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.direccionEmisor]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _withDirectives(_createElementVNode("select", {
                  id: "sexo",
                  type: "sexo",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.medico.sexo) = $event)),
                  class: "form-select"
                }, _hoisted_18, 512), [
                  [_vModelSelect, _ctx.medico.sexo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  id: "especialidad",
                  type: "especialidad",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.medico.especialidad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.especialidad]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  id: "exq",
                  type: "exq",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.medico.exq) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.exq]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  id: "cmd",
                  type: "cmd",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.medico.cmd) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.cmd]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  id: "claveDGII",
                  type: "claveDGII",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.medico.claveDGII) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.claveDGII]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", null, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  id: "telefono",
                  type: "telefono",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.medico.telefono) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.telefono]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  type: "email",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.medico.email) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.email]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", null, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  id: "observaciones",
                  type: "observaciones",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.medico.observaciones) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.observaciones]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("select", {
                  id: "estatus",
                  type: "estatus",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.medico.estatus) = $event)),
                  class: "form-select"
                }, _hoisted_38, 512), [
                  [_vModelSelect, _ctx.medico.estatus]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  id: "compGuberAsig",
                  type: "number",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.medico.compGuberAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.compGuberAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  id: "fechGuberAsig",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.medico.fechGuberAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.fechGuberAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  id: "compNoGuberAsig",
                  type: "number",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.medico.compNoGuberAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.compNoGuberAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  id: "compNoGuberAsig",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.medico.fechNoGuberAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.fechNoGuberAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  id: "compNoGuberAsig",
                  type: "datetime-local",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.medico.fechGuberAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.fechGuberAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  id: "compNdAsig",
                  type: "number",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.medico.compNdAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.compNdAsig]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  id: "compNcAsig",
                  type: "number",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.medico.compNcAsig) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.medico.compNcAsig]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.saveMedico()), ["prevent"])),
            disabled: 
            !_ctx.medico.emisor ||
            !_ctx.medico.direccionEmisor ||
            !_ctx.medico.rncEmisor ||
            !_ctx.medico.sexo ||
            !_ctx.medico.especialidad ||
            !_ctx.medico.exq ||
            !_ctx.medico.cmd ||
            !_ctx.medico.telefono ||
            !_ctx.medico.email ||
            !_ctx.medico.claveDGII ||
            !_ctx.medico.compGuberAsig ||
            !_ctx.medico.estatus
          
          }, " Guardar ", 8, _hoisted_49)
        ])
      ])
    ])
  ], 64))
}